module.exports = __webpack_public_path__ + "static/media/goodnest_app3.e13081cd.jpg";